// API base URL and key for authentication
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
export const API_KEY = import.meta.env.VITE_API_KEY || "scopingai";

// File upload configuration
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/msword", // .doc
  "text/plain",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
  "application/vnd.ms-powerpoint", // .ppt
  "text/markdown",
];

// Document status types
export const STATUS_TYPES = {
  DRAFT: "draft",
  IN_PROGRESS: "in_progress",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  COMPLETED: "completed",
  ARCHIVED: "archived",
};

// Chat configuration
export const MAX_CHAT_HISTORY = 10;
export const MAX_CHAT_LENGTH = 4000;

// API endpoints
export const ENDPOINTS = {
  // Knowledge base
  UPLOAD_FILE: "/api/revisr/documents",
  GET_DOCUMENTS: "/api/revisr/knowledge/documents",
  GET_DOCUMENT: "/api/revisr/knowledge/documents/:id",
  DELETE_DOCUMENT: "/api/revisr/knowledge/documents/:id",
  SEARCH_DOCUMENTS: "/api/revisr/knowledge/search",

  // Chat
  CHAT_COMPLETION: "/api/revisr/chat/completion",
  CHAT_HISTORY: "/api/revisr/chat/history",
  SAVE_CHAT: "/api/revisr/chat/save",

  // Progressive scoping
  PROGRESSIVE_SCOPING: "/api/revisr/scoping/progressive",
  GENERATE_SECTION: "/api/revisr/scoping/section",
  SAVE_SECTION: "/api/revisr/scoping/section/:id",
  GET_SECTIONS: "/api/revisr/scoping/sections",

  // Optimized proposal generation
  PROPOSALS_STREAM: "/api/revisr/proposals/stream",

  // Templates
  GET_TEMPLATES: "/api/templates",
  GET_TEMPLATE: "/api/templates/:id",
  SAVE_TEMPLATE: "/api/templates/:id",
  CREATE_TEMPLATE: "/api/templates",
  DELETE_TEMPLATE: "/api/templates/:id",

  // Clients
  GET_CLIENTS: "/api/clients",
  GET_CLIENT: "/api/clients/:id",
  SAVE_CLIENT: "/api/clients/:id",
  CREATE_CLIENT: "/api/clients",
  DELETE_CLIENT: "/api/clients/:id",

  // Documents
  EXPORT_PDF: "/api/revisr/documents/:id/export/pdf",
  EXPORT_WORD: "/api/revisr/documents/:id/export/word",
  DOCUMENT_LIBRARY: "/api/revisr/documents/library",
  DOCUMENT_BY_ID: "/api/revisr/documents/:id",

  // Prompt Templates
  PROMPT_TEMPLATES: "/api/revisr/prompt-templates",

  // Reference Documents
  REFERENCE_DOCUMENTS: "/api/revisr/reference-documents",
  REFERENCE_DOCUMENT_BY_ID: "/api/revisr/reference-documents/:id",

  // Quick Compare
  QUICK_COMPARE_CREATE_STORE: "/api/revisr/quick-compare/create-store",
  QUICK_COMPARE_UPLOAD: "/api/revisr/quick-compare/upload",
  QUICK_COMPARE_QUERY: "/api/revisr/quick-compare/query",
  QUICK_COMPARE_GENERATE_QUESTIONS: "/api/revisr/quick-compare/generate-questions",
  QUICK_COMPARE_DELETE_STORE: "/api/revisr/quick-compare/store/:id",
  QUICK_COMPARE_LIST_FILES: "/api/revisr/quick-compare/store/:id/files",
  QUICK_COMPARE_MULTI_COMPARE: "/api/knowledge/multi-compare",
  QUICK_COMPARE_MULTI_COMPARE_STREAM: "/api/knowledge/multi-compare/stream",

  // ParseDoc
  PARSEDOC_PARSE: "/api/revisr/parsedoc/parse",
};
